/**
 * 部署
 */
import React from 'react'
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import {
    Grid,
    Typography,
    Button,
    InputBase,
    FormControl,
    FormHelperText,
    IconButton,
    DialogTitle
} from '@material-ui/core';
import {
    ArrowUpward,
    ArrowDownward,
} from '@material-ui/icons';
import { getDepartment } from 'mdoc/admin/axios'
import { dictionary, getPermissions, getUserInfo } from 'mdoc/admin/axios'
import {
    addDepartment,
    deleteDepartmentById,
    updateDepartmentById,
    updateDepartmentSequence
} from 'mdoc/admin/axios/department';
import CustomizedTable from 'mdoc/utils/table'
import { messageFormat } from 'mdoc/utils';
import Dialog from 'mdoc/utils/myDialog';
import schema from 'async-validator';
import Toast from 'mdoc/utils/toast';


const styles = theme => ({
    appBarSpacer: theme.mixins.toolbar,
    margin: {
        margin: theme.spacing.unit,
    },
    bootstrapRoot: {
        'label + &': {
            marginTop: theme.spacing.unit * 3,
        }
    },
    bootstrapInput: {
        backgroundColor: theme.palette.common.white,
        border: '1px solid #ced4da',
        padding: '5px 6px',
        transition: theme.transitions.create(['border-color', 'box-shadow']),
        '&:focus': {
            borderColor: '#80bdff',
            boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
        },
        height: '19px'
    },
    button: {
        marginLeft: '20px',
    },
    title: {
        marginLeft: '-20px'
    }
});

class Department extends React.Component {
    state = {
        selectedRowKeys: [], // Check here to configure the default column
        data: [],
        loading: false,
        permissions: [],
        formData: {
            name: {
                value: '',
                error: false,
                errorMsg: ''
            },
            tableName: {
                value: '',
                error: false,
                errorMsg: ''
            },
            parentId: {
                value: '',
                error: false,
                errorMsg: ''
            },
            depth: {
                value: '',
                error: false,
                errorMsg: ''
            },
            parentIds: {
                value: '',
                error: false,
                errorMsg: ''
            }
        },
        dictWord: {
            'id': '',
            'code': '',
            'department_add': '',
            'department_list_edit': '',
            'new_insert': '',
            'department': '',
            'management': '',
            'modify_record': '',
            'delete_record': '',
            'add_record': '',
            'confirmation': '',
            'yes': '',
            'cancel': '',
            'msg_confirm_really_registration': '',
            'msg_error_not_null_with_item': '',
            'msg_confirm_really_delete': '',
            'add_insert': '',
            'restart': '',
            'msg_error_record_exists': '',
            'sort_order_save': '',
            'mst_error_record_not_found': '',
            'msg_save_success': '',
            'registration': '',
            'department_designation': '',
            'msg_error_over_length': '',
            'msg_error_department_name_exist': '',
            'msg_error_value_invalid': ''
        },
        dialogOpen: false,
        dialogMessage: '',
        dialogType: '',
        keyId: '',
        updateKey: '',
    }
    componentWillMount() {
        this.start(this.state);
        this.fetch()
    }
    componentDidMount() {
        const permissions = getPermissions() !== undefined ? getPermissions() : [];
        this.setState({
            permissions: permissions
        });
    }
    start = (state) => {
        this.setState({ loading: true });
        let dict = {}
        dictionary(state.dictWord).then(res => {
            for (let key in res) {
                let val = res[key];
                dict[val.dictKey] = val.dictValue;
            }
            this.setState({
                dictWord: dict,
            })
        })
    }


    fetch = (params = {}) => {
        this.setState({ loading: true })
        getDepartment({
            ...params
        }).then((data) => {
            let results = this.sortArray(0, data.results);
            this.setState({
                loading: false,
                data: results,
            })
        }).catch(error => {
            Toast.info(error)
        })
    }
    sortArray(id, oldData) {
        let newsArray = [];
        let j = 0;
        ParentArry(id);
        function ParentArry(id) {
            for (let i in oldData) {
                if (oldData[i].parentId === id) {
                    newsArray[j] = oldData[i];
                    j++;
                    ParentArry(oldData[i].id, newsArray, j);
                }
            }
        }
        return newsArray;
    }
    getMaxData(keyId) {
        let data = this.state.data.filter(item => item);
        let maxData = [];
        for (let index in data) {
            if (data[index].isadd === 1) continue;
            if (parseInt(data[index].parentId) === parseInt(data[keyId].parentId)) {
                maxData = data[index];
            }
        }
        return maxData;
    }
    getMinData(keyId) {
        let data = this.state.data.filter(item => item);
        let minData = [];
        for (let i = (keyId - 1); i >= 0; i--) {
            if (parseInt(data[i].depth) === parseInt(data[keyId].depth) && parseInt(data[i].parentId) === parseInt(data[keyId].parentId)) {
                minData = data[i];
                break;
            }
        }
        return minData;
    }
    clearArray() {
        let data = this.state.data.filter(item => item);
        for (let index in data) {
            if (!data[index].id) {
                this.state.data.splice(index, 1);
            }
        }
    }
    handleChange = (filed) => event => {
        let formData = this.state.formData;
        formData[filed] = Object.assign(this.state['formData'][filed], { value: event.target.value });
        this.setState({
            formData: formData
        });
    };
    handleSubmit = () => {
        const formData = this.state.formData;
        formData.parentId.value = 0;
        formData.depth.value = 1;
        formData.name.value = formData.name.value.replace(/\s+/g, "");
        let descriptor = {
            name: [
                { required: true, message: messageFormat(this.state.dictWord.msg_error_not_null_with_item, this.state.dictWord.department_designation) },
                { max: 40, required: true, message: messageFormat(this.state.dictWord.msg_error_over_length, this.state.dictWord.department_designation) },
            ]
        }
        const validator = new schema(descriptor);
        let emojiReg = /(\ud83c[\udf00-\udfff])|(\ud83d[\udc00-\ude4f])|(\ud83d[\ude80-\udeff])/g;
        let emojierr = false;
        if (formData.name.value.search(emojiReg) >= 0) {
            emojierr = true;
            formData['name'] = Object.assign(this.state['formData']['name'], {
                errorMsg: this.state.dictWord.msg_error_value_invalid,
                error: true
            })
        }
        if (emojierr === true) {
            this.setState({
                formData: formData
            });
            return;
        }
        validator.validate({ name: formData['name']['value'] }, {
            firstFields: true
        }, (errors, fields) => {
            for (let index in formData) {
                formData[index] = Object.assign(this.state['formData'][index], { errorMsg: '', error: false })
            }
            if (errors) {
                errors.forEach(item => {
                    formData[item.field] = Object.assign(this.state['formData'][item.field],
                        { errorMsg: item.message, error: true })
                });
                this.setState({
                    formData: formData
                });
            } else {
                this.setState({
                    dialogType: "add",
                    dialogOpen: true,
                    dialogMessage: this.state.dictWord['msg_confirm_really_registration'],
                });
            }
        })
    }
    handleTableSubmit = () => {
        const formData = this.state.formData;
        let keyId = this.state.keyId;
        let data = this.state.data[keyId];
        formData.parentId.value = data.parentId ? data.parentId : 0;
        formData.depth.value = data.depth ? data.depth : 1;
        formData.tableName.value = formData.tableName.value.replace(/\s+/g, "");

        let descriptor = {
            tableName: [
                { required: true, message: messageFormat(this.state.dictWord.msg_error_not_null_with_item, this.state.dictWord.department_designation) },
                { max: 40, required: true, message: messageFormat(this.state.dictWord.msg_error_over_length, this.state.dictWord.department_designation) },
            ]
        }
        const validator = new schema(descriptor);
        let emojiReg = /(\ud83c[\udf00-\udfff])|(\ud83d[\udc00-\ude4f])|(\ud83d[\ude80-\udeff])/g;
        let emojierr = false;
        if (formData.tableName.value.search(emojiReg) >= 0) {
            emojierr = true;
            formData['tableName'] = Object.assign(this.state['formData']['tableName'], {
                errorMsg: this.state.dictWord.msg_error_value_invalid,
                error: true
            })
        }
        if (emojierr === true) {
            this.setState({
                formData: formData
            });
            return;
        }
        validator.validate({ tableName: formData['tableName']['value'] }, {
            firstFields: true
        }, (errors, fields) => {
            for (let index in formData) {
                formData[index] = Object.assign(this.state['formData'][index], { errorMsg: '', error: false })
            }
            if (errors) {
                errors.forEach(item => {
                    formData[item.field] = Object.assign(this.state['formData'][item.field],
                        { errorMsg: item.message, error: true })
                });
                this.setState({
                    formData: formData
                });
            } else {
                this.setState({
                    dialogType: this.state.dialogType ? this.state.dialogType : "add",
                    dialogOpen: true,
                    dialogMessage: this.state.dialogMessage,
                });
            }
        })
    }
    dialogHandleOK = () => {
        let confirmData = this.state.formData;
        let keyId = this.state.keyId;
        switch (this.state.dialogType) {
            case "add":
                addDepartment({
                    departmentName: confirmData.name.value,
                    parentId: confirmData.parentId.value,
                    depth: confirmData.depth.value,
                    parentIds: confirmData.parentIds.value,
                }).then(res => {
                    confirmData.name.value = '';
                    this.setState({
                        formData: confirmData
                    });
                    this.fetch();
                }).catch(function (error) {
                    Toast.error(error);
                });
                confirmData.name.value = '';
                this.setState({
                    formData: confirmData
                });
                break;

            case "delete":
                deleteDepartmentById({
                    id: this.state.data[keyId].id
                }).then(res => {
                    this.setState({
                        data: []
                    });
                    this.fetch();
                }).catch(function (error) {
                    Toast.error(error);
                });
                this.fetch();
                break;

            case 'update':
                updateDepartmentById({
                    id: this.state.data[keyId].id,
                    parentId: this.state.data[keyId].parentId,
                    depth: this.state.data[keyId].depth,
                    departmentName: confirmData.tableName.value
                }).then(res => {
                    this.fetch();
                }).catch(function (error) {
                    Toast.error(error);
                })
                this.fetch();
                break;
            case 'addChild':
                addDepartment({
                    departmentName: confirmData.tableName.value,
                    parentId: this.state.data[keyId].parentId,
                    depth: this.state.data[keyId].depth,
                    parentIds: this.state.data[keyId].parentIds,
                }).then(res => {
                    this.fetch();
                }).catch(function (error) {
                    Toast.error(error);
                });
                this.fetch();
                break;
            default:
                break;
        }
        this.setState({
            dialogOpen: false,
            updateKey: '',
        });
    }
    dialogHandleClose = () => {
        this.setState({
            dialogOpen: false
        });
    }


    HandleTableDelete = (keyId) => event => {
        this.setState({
            keyId: keyId,
            dialogOpen: true,
            dialogType: 'delete',
            dialogMessage: this.state.dictWord['msg_confirm_really_delete'],
        });
    }
    HandleTableAddChild = (keyId) => event => {
        let parendData = this.state.data[keyId];
        let parentIds = (parendData.parentIds.length > 0 && parendData.parentIds !== 0) ? parendData.parentIds + "," + parendData.id : parendData.id;
        let ChildKey = 0;
        this.clearArray();
        let data = this.state.data;
        for (let i = 0; i < data.length; i++) {
            if (data[i].id === parendData.id) {
                keyId = i;
            }
            if (data[i].isadd === 1) {
                data[i].isadd = 0;
                this.setState({
                    data: data
                });
            }
        }
        for (let i = keyId + 1; i < this.state.data.length; i++) {//获取当前选中元素所有下级元素坐标
            if (this.state.data[i].depth === parendData.depth && this.state.data[i].parentId === parendData.parentId)
                break;
            if (parseInt(this.state.data[i].depth) < parseInt(parendData.depth)) break;
            if (parseInt(this.state.data[i].depth) > parseInt(parendData.depth)) {
                ChildKey = i;
            }
        }
        let addData = {
            categoryName: '',
            depth: (parseInt(parendData.depth) + 1),
            parentId: parendData.id,
            parentIds: parentIds,
            isadd: 1
        }
        let _key = ChildKey > 0 ? ChildKey + 1 : keyId + 1;
        this.state.data.splice(_key, 0, addData);
        let formData = this.state.formData;
        formData.tableName.errorMsg = '';
        formData.tableName.error = false;
        formData.tableName.value = '';
        this.setState({
            keyId: _key,
            updateKey: '',
            data: this.state.data,
            dialogType: 'addChild',
            dialogMessage: this.state.dictWord['msg_confirm_really_registration'],
            formData: formData
        });
    }
    HandleTableAddChildCancel = (keyId) => event => {
        this.state.data.splice(keyId, 1);
        this.setState({
            data: this.state.data,
            keyId: '',
            dialogType: ''
        });
    }
    HandleTableUpdate = (keyId) => event => {
        let formData = this.state.formData;
        formData.tableName.errorMsg = '';
        formData.tableName.error = false;
        formData.tableName.value = this.state.data[keyId].departmentName;

        this.setState({
            updateKey: keyId,
            keyId: keyId,
            dialogType: 'update',
            dialogMessage: this.state.dictWord['msg_confirm_really_registration'],
            formData: formData
        });
    }
    HandleTableUpdateCancel = () => event => {
        this.setState({
            updateKey: '',
            keyId: '',
            dialogType: '',
            dialogMessage: '',
        });
    }
    HandleTableMoveUp = (keyId) => event => {
        if (this.state.updateKey >= 0) {
            this.setState({
                updateKey: '',
                keyId: '',
                dialogType: '',
                dialogMessage: '',
            });
        }
        let sortData = this.state.data.filter(item => item);
        if ((keyId - 1) < 0) return;
        let thisData = sortData[keyId];
        let thisID = thisData.id;
        let targetID = 0;
        for (let i = (keyId - 1); i >= 0; i--) {
            if (sortData[i].depth === thisData.depth && sortData[i].parentId === thisData.parentId) {
                targetID = sortData[i].id;
                break;
            }
        }
        if (thisID && targetID) {
            updateDepartmentSequence({
                upId: targetID,
                downId: thisID
            }).then(res => {
                this.fetch();
            }).catch(function (error) {
                Toast.error(error);
            });
        }
    }
    HandleTableMoveDown = (keyId) => event => {
        if (this.state.updateKey >= 0) {
            this.setState({
                updateKey: '',
                keyId: '',
                dialogType: '',
                dialogMessage: '',
            });
        }
        let sortData = this.state.data.filter(item => item);
        if ((keyId + 1) > sortData.length) return;
        let thisData = sortData[keyId];
        let thisID = thisData.id;
        let targetID = 0;
        for (let i = (keyId + 1); i < sortData.length; i++) {
            if (sortData[i].depth === thisData.depth && sortData[i].parentId === thisData.parentId) {
                targetID = sortData[i].id;
                break;
            }
        }
        if (thisID && targetID) {
            updateDepartmentSequence({
                upId: thisID,
                downId: targetID
            }).then(res => {
                this.fetch();
            }).catch(function (error) {
                Toast.error(error);
            });
        }
    }

    render() {
        const { classes } = this.props;
        const { permissions } = this.state;
        const columns = [
            {
                title: this.state.dictWord.code,
                dataIndex: 'departmentCode',
                width: '105px',
                toolTipDisabled: true,
            }, {
                title: this.state.dictWord.department,
                dataIndex: 'departmentName',
                width: '60%',
                toolTipDisabled: true,
                render: (text, record, rowId) => {
                    let opt = <span style={{ marginLeft: 30 * (parseInt(record.depth) - 1) }}>{record.depth > 1 ? ' L ' + record.departmentName : record.departmentName} </span>;
                    if (this.state.updateKey === rowId || record.isadd === 1) {
                        opt = <span style={{ marginLeft: 30 * (parseInt(record.depth) - 1) }}>
                            <InputBase
                                id="tableName"
                                defaultValue={record.departmentName}
                                onChange={this.handleChange('tableName')}
                                fullWidth
                                classes={{
                                    root: classes.bootstrapRoot,
                                    input: classes.bootstrapInput,
                                }}
                                error={this.state.formData.tableName.error}
                                style={{ width: 200 }}
                            />
                            {this.state.formData.tableName.error ? <FormHelperText id="name-error-text" style={{ color: 'red', marginLeft: 30 * record.depth }} >{this.state.formData.tableName.errorMsg}</FormHelperText> : ''}
                        </span>
                    }
                    return opt;
                }
            },
        ]
        if (permissions.includes(4)) {
            columns.push({
                title: this.state.dictWord.management,
                key: 'action',
                toolTipDisabled: true,
                width: '370px',
                style:{
                    overflow: 'none',
                },
                render: (text, record, rowId) => {
                    let mindata = this.getMinData(rowId);
                    let maxdata = this.getMaxData(rowId);
                    let opt = <span>
                        <div style={{ width: 110, float: 'left', marginTop: 1, marginBottom: 1 }}>
                            <p style={{ width: 50, float: 'left', marginTop: 1, marginBottom: 1 }}>
                                {mindata.depth > 0 ? <IconButton color="primary" onClick={this.HandleTableMoveUp(rowId)}><ArrowUpward /></IconButton> : '  '}
                            </p>
                            <p style={{ width: 50, float: 'left', marginTop: 1, marginBottom: 1 }}>
                                {maxdata.id === record.id ? '  ' : <IconButton color="primary" onClick={this.HandleTableMoveDown(rowId)}>
                                    <ArrowDownward />
                                </IconButton>}
                            </p>
                        </div>
                        <Button variant="contained" color="primary" className={classes.margin} onClick={this.HandleTableUpdate(rowId)} disabled={parseInt(record.serverId ) === 0 ? false : true}>{this.state.dictWord.modify_record}</Button>
                        <Button variant="contained" color="primary" onClick={this.HandleTableDelete(rowId)} className={classes.margin} disabled={parseInt(record.serverId ) === 0 ? false : true}>{this.state.dictWord.delete_record}</Button>
                        {getUserInfo().departmentManagementAuth === 0 ? null : parseInt(record.depth) < 3 ?
                            <Button variant="contained" color="primary" onClick={this.HandleTableAddChild(rowId)} className={classes.margin}>{this.state.dictWord.add_record}</Button>
                            : ''}
                    </span>;
                    if (this.state.updateKey === rowId) {
                        opt = <span><Button variant="contained" color="primary" className={classes.margin} onClick={this.handleTableSubmit}>{this.state.dictWord['registration']}</Button>
                            <Button variant="contained" color="primary" className={classes.margin} onClick={this.HandleTableUpdateCancel()}>{this.state.dictWord['cancel']}</Button>
                        </span>;
                    }
                    if (record.isadd === 1) {
                        opt = <span><Button variant="contained" color="primary" className={classes.margin} onClick={this.handleTableSubmit}>{this.state.dictWord.add_insert}</Button>
                            <Button variant="contained" color="primary" className={classes.margin} onClick={this.HandleTableAddChildCancel(rowId)}>{this.state.dictWord['cancel']}</Button>
                        </span>;
                    }
                    return opt;
                }
            });
        }
        return (
            <div className="mainDom">
                <div className={classes.appBarSpacer} />
                {permissions.includes(4) ? <div>
                    <Typography variant="h6" gutterBottom>
                        {this.state.dictWord.department_add}
                    </Typography>
                    <Grid container className={classes.margin}>
                        <Grid item xs={12} md={3} style={{ maxWidth: '60%' }}>
                            <FormControl error={this.state.formData.name.error} fullWidth>
                                <InputBase
                                    id="name"
                                    value={this.state.formData.name.value}
                                    fullWidth
                                    onChange={this.handleChange('name')}
                                    classes={{
                                        root: classes.bootstrapRoot,
                                        input: classes.bootstrapInput,
                                    }}
                                    error={this.state.formData.name.error}
                                />
                                {this.state.formData.name.error ? <FormHelperText id="name-error-text">{this.state.formData.name.errorMsg}</FormHelperText> : ''}
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} md={2} style={{ maxWidth: '30%' }}>
                            <Button variant="contained" color="primary" className={classes.button} onClick={this.handleSubmit}>
                                {this.state.dictWord.new_insert}
                            </Button>
                        </Grid>
                    </Grid></div> : null}
                <Typography variant="h6" gutterBottom>
                    {this.state.dictWord.department_list_edit}
                </Typography>
                <Typography component="div">
                    <CustomizedTable
                        data={this.state.data}
                        columns={columns}
                        noPage
                    />
                </Typography>
                <Dialog
                    open={this.state.dialogOpen}
                    option={{
                        ok: {
                            text: this.state.dictWord['yes'],
                        },
                        close: {
                            text: this.state.dictWord['cancel'],
                        },
                    }}
                    titleDoc={<DialogTitle disableTypography id="" className={classes.title}>{this.state.dictWord['confirmation']}</DialogTitle>}
                    content={
                        <p>{this.state.dialogMessage}</p>
                    }
                    handleOk={this.dialogHandleOK}
                    handleClose={this.dialogHandleClose}
                />
            </div>
        )
    }
}

Department.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Department);